module.exports = __webpack_public_path__ + "static/media/close-primary.f24bd80d.svg";